<template>
  <b-modal
    @hidden="hidden"
    id="modal-feedback"
    ref="modal-feedback"
    footer-class="justify-content-start"
    size="xl"
  >
    <template v-slot:modal-title>
      <h4 class="p-3 mb-0 font-weight-boldy">Write to us</h4>
    </template>
    <b-container fluid>
      <b-row align-h="between" class="mb-3">
        <b-col cols="12" sm="6" md="4">
          <R-Select
            :labelValue="'Feedback:'"
            placeholder="feedback type"
            :size="'small'"
            :value="feedbackType"
            :options="sfeedbackTypes"
            ref="feedbackType"
            @onChange="
              $event
                ? (feedbackType = { label: $event.label, value: $event.value })
                : (searchField = null)
            "
          ></R-Select>
        </b-col>
        <b-col cols="auto"> Date: {{ date }} </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea
            placeholder="Your message"
            class="text-area"
            :rows="8"
            :maxlength="1800"
            v-model="feedbackMessage"
          ></b-form-textarea>
          <span class="pull-right">{{ feedbackMessageLength }}/1800</span>
        </b-col>
      </b-row>
    </b-container>

    <template v-slot:modal-footer="{ cancel }">
      <R-Button
        class="ml-3"
        :size="'small'"
        :disabled="feedbackMessageLength == 0"
        @onClick="send()"
        >Send</R-Button
      >
      <R-Button class="ml-3" :size="'small'" @onClick="goToRoom()"
        >Go to Feedback room</R-Button
      >
      <R-Button :size="'small'" @onClick="cancel()">Cancel</R-Button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { notify, TYPE } from "@8x8/oxygen-toaster";
import axios from "axios";
import { EMAIL_BASE_URL } from "@/vue/store/urls";

export default {
  data() {
    return {
      sfeedbackTypes: [
        {
          value: "generalFeedback",
          label: "General Feedback",
        },
        {
          value: "featureRequest",
          label: "Feature Request",
        },
        {
          value: "bug",
          label: "Bug",
        },
      ],
      feedbackType: {
        value: "generalFeedback",
        label: "General Feedback",
      },
      feedbackMessage: "",
      successMessage: "Thanks! Your feedback has been submited",
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    feedbackMessageLength: function () {
      return this.feedbackMessage.length;
    },
    date() {
      return moment(new Date()).format("MM/DD/YYYY, hh:mm a");
    },
  },
  methods: {
    send() {
      let message =
        this.feedbackType.label +
        " - " +
        this.date +
        " - " +
        this.getUser.name +
        " - " +
        this.feedbackMessage;
      let personalizations = [];
      personalizations.push({
        to: [
          { email: "slobodan.miskovic@8x8.com", name: "Slobodan Miskovic" },
          { email: "tin.ilakovac@8x8.com", name: "Tin Ilakovac" },
          { email: "ana.tarita@8x8.com", name: "Ana Tarita" },
          { email: "malin.branduse@8x8.com", name: "Malin Branduse" },
          { email: "calin.negreanu@8x8.com", name: "Calin Negreanu" },
        ],
        subject: "Tool 8 Feedback",
      });
      let body = {
        personalizations: personalizations,
        from: { email: "noreply@8x8.com", name: "8x8 Inc" },
        reply_to: { email: "noreply@8x8.com", name: "8x8 Inc" },
        content: [
          {
            type: "text/plain",
            value: message,
          },
        ],
      };
      let mail = this.$http.post(EMAIL_BASE_URL, body);
      let chat = this.$http.post("/v1/sendComment", {
        feedbackContent: message,
      });

      axios
        .all([mail, chat])
        .then(
          axios.spread((...res) => {
            console.log("response spread:");
            console.log(res);
            this.hideModal();
            notify({ content: "Feedback sent... Thank you!!", duration: 5000 });
            this.goToRoom();
          })
        )
        .catch((error) => {
          console.log("error");
          console.log(error.message);
          this.reset();
          notify({
            content: error.message,
            type: TYPE.error,
            duration: 5000,
          });
        });
    },
    hideModal() {
      this.$refs["modal-feedback"].hide();
    },
    reset() {
      this.feedbackMessage = "";
      this.feedbackType = {
        value: "generalFeedback",
        label: "General Feedback",
      };
    },
    hidden() {
      this.reset();
    },
    goToRoom() {
      window.open(
        "vo://conversations/chat/f%3AScNyJ7noShsJshzaa98WUlfL8EZkyxVnhsO0Aes4FRA"
      );
    },
  },
};
</script>
